import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'percentage',
})
export class PercentagePipe implements PipeTransform {
    transform(value: number): string {
        return `${Math.ceil(value)}%`;
    }
}
